
import { TextareaProps } from "./textarea.props";
import { Textarea } from "./textarea.styled";

const AGTextarea: React.FC<TextareaProps> = ({ ...props }) => {
    return (
        <Textarea {...props} />
    );
};

export default AGTextarea;
